import apiClient from '@/service/apiClient';

export type ResGetReservationTop10 = {
  isSuccess: boolean;
  code: number;
  message: string;
  correlationId: string;
  result: Array<{
    id: number;
    name: string;
    location: string;
    categoryId: number;
    categoryName: string;
    villageName: string;
    price: number;
    originPrice: number;
    thumbnailUrl: string;
    productType: string;
    reservationCount: number;
  }>;
};

export const getReservationTop10 = async (): Promise<ResGetReservationTop10> => {
  const { data } = await apiClient.get<ResGetReservationTop10>(
    '/app/products/v2/reservation/top-10'
  );
  return data;
};
